$bog_ui_app_breadcrumb $mol_page
	title \Breadcrumb
	body /
		<= Description $mol_view
			sub /
				<= description \Navigation breadcrumbs showing the user's current location in a hierarchy.
		<= Short_title $mol_view
			sub /
				<= short_title \Short Path (2 levels)
		<= Short $bog_ui_breadcrumb
			crumbs <= short_crumbs /
		<= Long_title $mol_view
			sub /
				<= long_title \Long Path (5 levels)
		<= Long $bog_ui_breadcrumb
			crumbs <= long_crumbs /
